import * as React from 'react';
import {BlurbWrapper,
	Content,
	Title, Wrapper} from './BlurbStyles';
import {language} from './BlurbLanguage'
import { generateBlurb } from '../../helpers/generateBlurbParas';

export type Props = {
	blurbSection: any;
};

export const BlurbLayout = (props: Props) =>
{
	const render = () =>
	{
		const blurbContent = generateBlurb(props.blurbSection.paras)
		const returnValue = (
			<BlurbWrapper>
				<Wrapper>
					<Title>
						{props.blurbSection.title}
					</Title>
					<Content>
						{blurbContent}
					</Content>
				</Wrapper>
			</BlurbWrapper>
		);
		return returnValue;
	};
	const outerReturnValue = render();
	return outerReturnValue;
};
